import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import EffectThemeTabButton from "../effectTheme/effectThemeButtons";
import AILogo from "../app/icons/AILogo";
import { isFeatureEnabled } from "../../features";
import { ButtonAiFullProps, ButtonAiIconOnlyProps, ButtonAIProps, ButtonAiWithoutCreditsProps, ButtonAiWithoutTextProps } from "../../types/ui/sendButtons";

const defaultSendIcon = <FontAwesomeIcon icon={faLocationArrow} style={{ transform: "rotate(45deg)"}} className="me-2" size="xl"/>;

export const SendButtonAI = ({
    buttonClass,
    buttonWidth,
    buttonHeight,
    icon,
    showIcon,
    credits,
    showCredits,
    creditText,
    text,
    showText,
    showAILogo,
    ...props
}:ButtonAIProps) => {
    const [t] = useTranslation('generation');
    // Masterplan Paket 3: Credit-Anzeige zentral hier abgeschaltet (creditsUi, nur Dev) - deckt alle
    // Send-Button-Varianten und Aufrufer ab, die weiterhin credits= durchreichen duerfen.
    const creditsVisible = showCredits && isFeatureEnabled('creditsUi');
    const buttonStyle: React.CSSProperties ={
        width: buttonWidth,
        height: buttonHeight,
        ...props.style
    };

    return (
    <>
        <EffectThemeTabButton
            {...props}
            className={`${buttonClass ?? "btn btn-outline-secondary rounded p-1"}`}
            title={props.title}
            disabled={props.disabled}
            style={buttonStyle}
            children ={ 
                <>
                    <div className="row m-0 p-0 align-items-center">
                        <div className="col m-0 p-0" />
                        <div className="col-auto m-0 p-0 d-flex align-items-center">
                            { showIcon && icon && (icon) }
                        </div>
                        <div className="col-auto m-0 p-0 d-flex align-items-center">
                            { showText && text && (text) }
                        </div>
                        <div className="col-auto m-0 p-0 d-flex align-items-center">
                            { showAILogo && (<AILogo className="ms-2"/>) }
                        </div>
                        <div className="col m-0 p-0" />

                        {
                            creditsVisible && showText && (
                                <p className="text-small text-secondary m-0 p-0">{creditText ?? t('coins')} {credits ?? 0}</p>
                            )
                        }
                    </div>
                </>
            }
        />
        {
            creditsVisible && !showText && (
                <p className="text-small text-secondary m-0 p-0">{creditText ?? t('coins')} {credits ?? 0}</p>
            )
        }
    </>);
};

export const SendButtonAiFull = ({
    buttonClass,
    buttonWidth='100%',
    buttonHeight='60px',
    icon,
    text,
    credits=0,
    creditText,
    showAILogo=true,
    ...props
}: ButtonAiFullProps) => {
    const [t] = useTranslation('generation');
    return (
        <SendButtonAI
            {...props}
            buttonClass={buttonClass}
            buttonHeight={buttonHeight}
            buttonWidth={buttonWidth}
            icon={icon ?? defaultSendIcon}
            showIcon={true}
            text={text ?? t('send')}
            title={props.title ?? t('send')}
            showText={true}
            credits={credits}
            creditText={creditText ?? t('coins')}
            showCredits={true}
            showAILogo={showAILogo}
        />
    );
};

export const SendButtonAiWithoutCredits = ({
    buttonClass,
    buttonWidth='100%',
    buttonHeight='60px',
    icon,
    text,
    showAILogo=true,
    ...props
}: ButtonAiWithoutCreditsProps) => {
    const [t] = useTranslation('generation');
    return (
        <SendButtonAI
            {...props}
            buttonClass={buttonClass}
            buttonHeight={buttonHeight}
            buttonWidth={buttonWidth}
            icon={icon ?? defaultSendIcon}
            showIcon={true}
            text={text ?? t('send')}
            title={props.title ?? t('send')}
            showText={true}
            showCredits={false}
            showAILogo={showAILogo}
        />
    );
};

export const SendButtonAiWithouText = ({
    buttonClass,
    buttonWidth='100%',
    buttonHeight='60px',
    icon,
    credits=0,
    creditText,
    showAILogo=true,
    ...props
}: ButtonAiWithoutTextProps) => {
    const [t] = useTranslation('generation');
    return (
        <SendButtonAI
            {...props}
            buttonClass={buttonClass}
            buttonHeight={buttonHeight}
            buttonWidth={buttonWidth}
            icon={icon ?? defaultSendIcon}
            showIcon={true}
            title={props.title ?? t('send')}
            showText={false}
            credits={credits}
            creditText={creditText ?? t('coins')}
            showCredits={true}
            showAILogo={showAILogo}
        />
    );
};

export const SendButtonAiIconOnly = ({
    buttonClass,
    buttonWidth='100%',
    buttonHeight='42px',
    icon,
    showAILogo=false,
    ...props
}: ButtonAiIconOnlyProps) => {
    const [t] = useTranslation('generation');
    return (
        <SendButtonAI
            {...props}
            buttonClass={buttonClass}
            buttonHeight={buttonHeight}
            buttonWidth={buttonWidth}
            icon={icon ?? defaultSendIcon}
            title={props.title ?? t('send')}
            showIcon={true}
            showText={false}
            showCredits={false}
            showAILogo={showAILogo}
        />
    );
};